<template>
  <div class="bg-img width-100 min-height flex-column justify-content-spaceBetween align-items-center">
    <div class="width-100">
      <img src="../../assets/image/msxc/2.png" width="100%" alt="" />
      <div class="width-100 padding-lr">
        <div class="container van-overflow-hidden">
          <div class="main">
            <p class="fw-mid fs-big black textAlign-c margin-bs">反映问题须知</p>
            <p class="fs-mid black text-indent line-height2 margin-b">{{ config.wtxz }}</p>
            <p class="fw-mid fs-big black text-indent margin-bs">受理范围</p>

            <p class="fs-mid black text-indent line-height2 margin-b">{{ config.slfw }}</p>
            <van-checkbox v-model="checked" class="margin-t margin-b" shape="square" checked-color="rgb(235, 76, 72)">我已阅读以上条款</van-checkbox>
          </div>
          <div class="btn-box flex-row justify-content-around align-items-center">
            <van-button color="#FF5033" plain class="width-40" size="small" @click="goForm(2)">匿名举报</van-button>
            <van-button color="#DC4223" class="width-40" size="small" @click="goForm(1)">实名举报</van-button>
          </div>
        </div>
      </div>
    </div>
    <p class="white">{{ config.lk }}</p>
  </div>
</template>
<script>
import { config } from '@/api/msxcApi';
import { Toast } from 'vant';

export default {
  name: 'msxcIndex',
  data() {
    return {
      config: {},
      checked: false
    };
  },
  created() {
    config().then((res) => {
      this.config = res.data;
    });
  },
  methods: {
    goForm(ay) {
      let now = new Date();
      if (now < this.config.beginTime) {
        Toast.fail('当前举报未开始');
      } else if (now > this.config.endTime) {
        Toast.fail('当前举报已结束');
      } else {
        if (this.checked) {
          this.$router.push({ path: '/msxcForm', query: { ay: ay } });
        } else {
          Toast.fail('请勾选阅读条款');
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../assets/css/common.css';
@import '../../assets/css/demo1.css';
@import '../../assets/css/demo2.css';
.bg-img {
  background: url('../../assets/image/msxc/bg.jpg') rgb(235, 76, 72) no-repeat top center;
  background-size: 100%;
  padding: 140px 5% 40px;
  .container {
    width: 100%;
    background: #fff4f4;
    border-radius: 5px;
    position: relative;
    top: -20px;
    .main {
      padding: 20px 8%;
    }
  }
  .btn-box {
    background: #ffebe0;
    padding: 30px 8%;
  }
}
img {
  vertical-align: middle;
}
</style>
